import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { createCategory } from '../../../redux/actions/categories'
import { useNavigate } from 'react-router-dom'
import Page from '../../../components/Page'
import CategoryForm from '../../../components/forms/CategoryForm'

const CategoriesAdd = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { isChangeLoading } = useSelector((state) => state.categories)

  const submitHandler = (data) => {
    dispatch(
      createCategory({
        data,
        navigate,
      }),
    )
  }

  return (
    <Page pageTitle={t('categories.new category')} withCancelBtn={true}>
      <CategoryForm submitHandler={submitHandler} loading={isChangeLoading} />
    </Page>
  )
}

export default CategoriesAdd
